import {Component, OnInit, Input, EventEmitter, HostListener, ElementRef, ViewContainerRef, DebugElement} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouterModule, Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { SharedData } from '../../shared/sharedData';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import * as _ from 'underscore';
import { Auth } from '../../shared/services/auth';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { TranslateService } from '@ngx-translate/core';
 
@Component({
selector: 'password-policy',
templateUrl: 'passwordPolicy.html'
})
export class PasswordPolicyComponent {
    public _baseUrl: any;
    public displayPreferences: any = 2;
    public passwordPolicyData: any;
    constructor(
      public route: ActivatedRoute,
      public activeModal: NgbActiveModal,
      public _location: Location,
      public _toast: ToasterComponent,
      public viewContainerRef: ViewContainerRef,
      public _http: HttpClientCustom,
      public _global: Configuration,
      public translate: TranslateService,
      public _share: SharedData,
      public _auth: Auth,
    ) {
        let self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self.getPasswordPolicy();
    }

    public getPasswordPolicy(): any {
        try {
            let self =this;
            let url = self._baseUrl + 'v1/webAdmin/passwordPolicy';
            self._http.get(url).subscribe((passwordPolicyData) => {
                self.passwordPolicyData = passwordPolicyData.data;
            },(error) => {
                console.log('Password Policy Get Error', error);
            });
        } catch (e) {
            console.log('Password Policy Get Error', e);
        }
    }

    public validatepasswordPolicy(){
      
      let self = this;
      if(self.passwordPolicyData['minLength']!=null && self.passwordPolicyData['minLength']!=0){
        if(self.passwordPolicyData['maxLength']!=null && self.passwordPolicyData['maxLength']!=0){
          self.saveTenantConfigData();
        }else{
          self._toast.showError("Not a valid password policy, Please add valid min and max length");
        }
      }else{
        self._toast.showError("Not a valid password policy, Please add valid min and max length");
      }
    }

    public saveTenantConfigData(): any {
      try {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/passwordPolicy';
        self._http.post(url, self.passwordPolicyData).subscribe((result) => {
          if (result.data.id) {
            self.translate.get('updatedSuccessfully').subscribe((msg) => {
              self._toast.showSuccess(msg);
            });
          } else {
            self.translate.get('errorWhileSaving').subscribe((msg) => {
              self._toast.showError(msg);
            });
          }
        });
      } catch (error) {
        console.log('Password Policy Save Error', error);
      }
    }
  }



// WEBPACK FOOTER //
// ./src/app/tools/passwordPolicy/passwordPolicy.ts